var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
require('../../src/js/vendor/slick.js');
//require('slick-carousel');


/**
 * Initializes the site header.
 * @constructor
 * @param {Object} el - The site header element.
 */
function UpcomingDates(el) {
  this.el = el;
  this.$el = $(el);

  var $ww = $(window).width();
	var item_length = $('.js-upcoming-dates-slider > div').length;

 		$('.js-upcoming-dates-slider').slick({
 			arrows: true,
			infinite: false,
			autoplay: false,
			slidesToShow: 6,
			slidesToScroll: 1,
			responsive: [
		    {
		      breakpoint: 1025,
		      settings: {
		        slidesToShow: 4
		      }
		    },
		    {
		      breakpoint: 850,
		      settings: {
		        slidesToShow: 3
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		        slidesToShow: 2
		      }
		    },
		    {
		      breakpoint: 450,
		      settings: {
		        slidesToShow: 1
		      }
		    }
		  ],
		  prevArrow:'<span class="slick-prev"><i class="jp-icon-arrow-thin-left "></i></span>',
		  nextArrow:'<span class="slick-next"><i class="jp-icon-arrow-thin-right"></i></span>'
		});

	/*$(window).on('resize', function(){
		console.log($ww);
    if( $ww < 1200) {
      $('.js-upcoming-dates-slider').slick('getSlick');
    }
    else if ( $ww > 1200 && item_length <= 6 ) {
    	$('.js-upcoming-dates-slider').slick('unslick');
    }
  });*/
 }

module.exports = UpcomingDates;